<template>
  <div>
    <nav-title :color="false" :title="'Learn More'" />
    <h5 class="text-center mt-3 text-darked">
      {{ getSkillDescription.text }}
    </h5>
    <div
      v-html="getSkillDescription.description"
      class="py-3 container px-lg-5 full-size-img"
    ></div>
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  components: {
    navTitle
  },
  computed: {
    ...mapGetters("help", ["getSkillDescription"])
  },
  beforeRouteEnter(to, from, next) {
    let skill = to.query.skill;
    Promise.all([store.dispatch("help/FetchSkillDescription", skill)]).then(
      () => {
        next();
      }
    );
  }
};
</script>
<style lang="scss">
.full-size-img img {
  width: 100% !important;
}
</style>